import { Link } from 'react-router-dom';

export default function FeaturedGuides() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              Featured Guides
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              Expert-curated LitBuy Spreadsheet resources to help you get started, stay safe, and maximize your shopping efficiency
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {/* Guide 1: What Is a LitBuy Spreadsheet? */}
            <Link
              to="/what-is-litbuy-spreadsheet"
              className="group relative block aspect-[4/3] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20wooden%20desk%20with%20open%20laptop%20showing%20colorful%20data%20charts%20surrounded%20by%20product%20catalog%20magazine%20coffee%20mug%20and%20reading%20glasses%2C%20golden%20hour%20sunlight%20through%20window%20blinds%2C%20cozy%20study%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20warm%20amber%20and%20cream%20tones&width=800&height=600&seq=feat-guide-v2-01&orientation=landscape"
                alt="What Is a LitBuy Spreadsheet?"
                title="What Is a LitBuy Spreadsheet? Complete guide"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-white leading-snug">
                  What Is a LitBuy Spreadsheet?
                </h3>
                <p className="mt-2 text-xs md:text-sm text-white/75 leading-relaxed line-clamp-2">
                  A complete introduction to LitBuy Spreadsheets, how they work, and why they are essential for smart shoppers and product researchers.
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-accent-300 whitespace-nowrap">
                  Read More <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                </span>
              </div>
            </Link>

            {/* Guide 2: Shopping Guide */}
            <Link
              to="/shopping-guide"
              className="group relative block aspect-[4/3] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Neatly%20stacked%20books%20and%20magazines%20on%20midcentury%20modern%20side%20table%20with%20warm%20table%20lamp%20glow%20and%20potted%20snake%20plant%2C%20evening%20ambient%20lighting%2C%20sophisticated%20reading%20nook%20photography%2C%20intellectual%20cozy%20aesthetic%2C%20rich%20dark%20wood%20and%20warm%20light%20tones&width=800&height=600&seq=feat-guide-v2-02&orientation=landscape"
                alt="LitBuy Shopping Guide Collection"
                title="LitBuy Spreadsheet Shopping Guide Collection"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-white leading-snug">
                  Complete Shopping Guide
                </h3>
                <p className="mt-2 text-xs md:text-sm text-white/75 leading-relaxed line-clamp-2">
                  Browse all 9 LitBuy Spreadsheet guides covering usage, templates, safety, workflow optimization and more.
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-accent-300 whitespace-nowrap">
                  View All Guides <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                </span>
              </div>
            </Link>

            {/* Guide 3: Safety Guide */}
            <Link
              to="/article/is-litbuy-spreadsheet-safe"
              className="group relative block aspect-[4/3] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20white%20desk%20with%20modern%20minimal%20shield%20shaped%20paperweight%20next%20to%20laptop%20and%20small%20succulent%20plant%2C%20soft%20overcast%20daylight%20through%20sheer%20curtains%2C%20calm%20professional%20photography%2C%20trust%20and%20security%20concept%2C%20Serene%20sage%20green%20and%20white%20palette&width=800&height=600&seq=feat-guide-v2-03&orientation=landscape"
                alt="LitBuy Spreadsheet Safety Guide"
                title="LitBuy Spreadsheet Safety Guide"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-white leading-snug">
                  LitBuy Spreadsheet Safety Guide
                </h3>
                <p className="mt-2 text-xs md:text-sm text-white/75 leading-relaxed line-clamp-2">
                  Learn about the safety features of LitBuy Spreadsheets, data protection best practices, and how to keep your information secure.
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-accent-300 whitespace-nowrap">
                  Read More <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}